
import React from 'react';
import { 
  Card, 
  CardContent, 
  CardDescription, 
  CardHeader, 
  CardTitle 
} from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { MessageCircle } from 'lucide-react';
import { useToast } from '@/hooks/use-toast';
import TranslatedText from '@/TranslatedText';

const LiveSupportSection = () => {
  const { toast } = useToast();
  
  return (
    <Card>
      <CardHeader>
        <CardTitle><TranslatedText text="Live Support" /></CardTitle>
        <CardDescription>
          <TranslatedText text="Chat with our virtual assistant or get connected to a support agent." />
        </CardDescription>
      </CardHeader>
      <CardContent className="h-[400px] flex items-center justify-center border rounded-md">
        <div className="text-center">
          <MessageCircle className="h-16 w-16 mx-auto text-ahavex-blue opacity-20 mb-4" />
          <h3 className="text-xl font-medium mb-2"><TranslatedText text="Start a Conversation" /></h3>
          <p className="text-muted-foreground mb-4">
            <TranslatedText text="Our support team is ready to assist you with any questions." />
          </p>
          <Button onClick={() => {
            toast({
              title: "Chat initiated",
              description: "A chat support agent would connect here in a real implementation",
            });
          }}>
            <MessageCircle className="mr-2 h-4 w-4" />
            <TranslatedText text="Start Chat" />
          </Button>
        </div>
      </CardContent>
    </Card>
  );
};

export default LiveSupportSection;
